<page-toolbar title="{{'globalVariables.title' | translate}}"></page-toolbar>

<data-table [columns]="columns" [newHeader]="true" [dataProvider]="varService" [headerButtons]="headerButtons" (edit)="edit($event)"></data-table>
